import { defineComponent as _defineComponent } from 'vue'
import path from 'path'
import { withDefaults, computed } from 'vue'
import { RouteConfig } from 'vue-router'
import { isExternal } from '@/utils/validate'
import SidebarItemLink from './SidebarItemLink.vue'
import SidebarItem from './SidebarItem.vue'
import { UserModule } from '@/store/modules/user'


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarItem',
  props: {
    item: null,
    isCollapse: { type: Boolean, default: false },
    isFirstLevel: { type: Boolean, default: true },
    basePath: { default: '' }
  },
  setup(__props: any) {

const props = __props as { item: RouteConfig, isCollapse: boolean, isFirstLevel: boolean, basePath: string }



/**
 *
 * 检查当前项在有孩子的情况下，是不是所有孩子都不可见？
 */
const hasNoVisibleChildren = computed(() => {
  // 当前项中不可见孩子数量与数组长度相同时，表示没有可见孩子，因此返回true
  if (
    Array.isArray(props.item?.children) &&
    props.item?.children?.filter((item) => {
      return item.meta?.hidden === true
    }).length === props.item?.children?.length
  ) {
    return true
  }
  return false
})

const showingChildNumber = computed(() => {
  if (props.item.children) {
    const showingChildren = props.item.children.filter((item) => {
      if (item.meta?.hidden === true) {
        return false
      } else {
        return true
      }
    })
    return showingChildren.length
  }
  return 0
})

const theOnlyOneChild = computed(() => {
  if (showingChildNumber.value > 1) {
    return null
  }
  if (props.item.children) {
    // 当一级菜单下只有一个二级菜单有权限时需要显示一级菜单
    if (props.item.meta && props.item.meta.icon) {
      return props.item
    }
    for (const child of props.item.children) {
      if (!child.meta || !child.meta.hidden) {
        return child
      }
    }
  }
  // If there is no children, return itself with path removed,
  // because this.basePath already conatins item's path information
  return { ...props.item, path: '' }
})

function resolvePath(routePath: string) {
  if (isExternal(routePath)) {
    return routePath
  }
  if (isExternal(props.basePath)) {
    return props.basePath
  }
  // 已经拼接了，不再拼接
  if (props.basePath.slice(-routePath.length) === routePath) {
    return props.basePath
  }
  return path.resolve(props.basePath, routePath)
}

const isVisible = computed(() => {
  const { meta } = props.item
  if (meta === undefined) {
    return true
  } else {
    if (meta.hidden !== undefined) {
      return !meta.hidden
    } else if (meta.roles !== undefined) {
      return meta.roles.includes(UserModule.userInfo.role)
    } else {
      return true
    }
  }
})

return { __sfc: true,props, hasNoVisibleChildren, showingChildNumber, theOnlyOneChild, resolvePath, isVisible, path, SidebarItemLink, SidebarItem }
}

})